import { MembershipContacts } from '@models';

export interface GetMembershipContactsResult {
  membershipContacts: MembershipContacts;
}
